
export default {

  name: 'category-block',

  props: {
    block: {}
  },

  created: function () {
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/categoryBlock/CategoryBlock.js